import { bonusStatuses, bonusTypes } from 'src/common/constants';

const { DEPOSIT, RELOAD_DEPOSIT } = bonusTypes;
const { ACTIVATED } = bonusStatuses;

export const checkDepositBonusTypeFits = bonusType => [DEPOSIT, RELOAD_DEPOSIT].includes(bonusType);

export const getBonusActivationSortValue = bonus => bonus?.createTime ?? bonus?.id ?? 0;

export const normalizeBonusWithFinanceData = (bonus, currency) => {
  const normalizedBonus = bonus?.bonus ?? bonus;
  const financeData =
    normalizedBonus?.financeDataList?.find(item => item.currency === currency) ??
    bonus?.financeData;

  return {
    ...bonus,
    ...normalizedBonus,
    financeData,
    id: bonus?.id ?? normalizedBonus?.id,
  };
};

export const getBonusMinDeposit = (bonus, currency) =>
  bonus?.financeData?.minDeposit ??
  bonus?.financeDataList?.find(item => item.currency === currency)?.minDeposit ??
  0;

export const findLatestActivatedBonus = ({ activeBonuses, isMatchingBonus }) =>
  activeBonuses
    .filter(({ bonus, status }) => status === ACTIVATED && isMatchingBonus(bonus))
    .reduce((latestBonus, currentBonus) => {
      if (!latestBonus) {
        return currentBonus;
      }

      return getBonusActivationSortValue(currentBonus) >= getBonusActivationSortValue(latestBonus)
        ? currentBonus
        : latestBonus;
    }, null);

export const findTransportMatchedBonus = ({
  activeBonuses,
  bonusId,
  bonusInstanceId,
  bonuses,
  currency,
  isMatchingBonus,
}) => {
  const matchedActiveBonus = activeBonuses.find(({ bonus, id }) => {
    return isMatchingBonus(bonus) && (id === bonusInstanceId || bonus?.id === bonusId);
  });

  if (matchedActiveBonus) {
    return normalizeBonusWithFinanceData(matchedActiveBonus, currency);
  }

  const matchedAvailableBonus = bonuses.find(bonus => {
    return isMatchingBonus(bonus) && bonus.id === bonusId;
  });

  if (!matchedAvailableBonus) {
    return null;
  }

  return normalizeBonusWithFinanceData(matchedAvailableBonus, currency);
};
